

<template>
  <InputMoney
    v-model="value"
    hide-details
    :sem-label="true"
  />
</template>

<script>
import { InputMoney } from '@components/inputs';
export default {
    components:{
        InputMoney
    },
    props:{
        criterio: {
        default: '',
        required: false,
        }
    },
    data() {
        return {
            value: 0
        }
    },
    mounted(){
        this.setup()
    },        
    methods: {
        setup(){
            let criterios = this.$store.getters['criterios/getCriterios']
            const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia)
            
            if(itemEncontrado) {
                this.value = itemEncontrado.valorTotalOrcamento
            }
        },
    },
    watch:{
        value(valor){
            this.$emit('retornoValores', { valorTotalOrcamento: valor });
            
            if (!valor) return;
            
            let criterios = this.$store.getters['criterios/getCriterios'];
            const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia);

            if (itemEncontrado) {
                itemEncontrado.valorTotalOrcamento = valor
                this.$store.dispatch('criterios/updateCriterio', { updatedCriterio: itemEncontrado });
                return 
            }

            this.$store.dispatch('criterios/updateCriterio', { updatedCriterio: this.criterio });
        }
    },
};
</script>   
